module.exports = __webpack_public_path__ + "static/media/yellow_button1.88f2b3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yellow_button1.png
// module id = 45
// module chunks = 0